/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Event_Group_OptionsInputs */



/**
* | output |
* | --- |
* | "Event group options" |
*
* @param {Editor_Event_Group_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_event_group_options = /** @type {((inputs?: Editor_Event_Group_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Event_Group_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options du groupe d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optionen für Veranstaltungsgruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("параметры группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de grupo de eventos")
	return /** @type {LocalizedString} */ ("Event group options")
});